// Configuration for switching between Carto, ArcGIS, and databridge data sources
// Change individual values to 'carto', 'arcgis', or 'databridge' as needed.
// 'databridge' calls databridge-api on the phila.gov gateway directly, with a loud
// runtime fallback to direct carto (see src/util/databridge.js).

// MASTER SWITCH: set false to move EVERY call off databridge at once (incident
// rollback when the gateway/databridge chain is down). Each 'databridge' dataset
// drops to a direct branch and the per-dataset values below still control routing
// individually while this is true.
export const USE_DATABRIDGE = true;

const DATABRIDGE_SOURCES = {
  // Main property history sources - databridge first with loud carto fallback;
  // 'arcgis' still selects the preserved AGO branches
  violations: 'databridge',
  permits: 'databridge',
  appeals: 'databridge',
  businessLicenses: 'databridge',

  // Building certifications
  buildingCertSummary: 'databridge',
  buildingCerts: 'databridge',

  // Other sources
  mailingAddress: 'databridge',
  investigations: 'databridge',
  zoningDocs: 'databridge',
  // find-a-licensed-contractor: the licenses table pages server-side (LIMIT/OFFSET)
  contractorLicenses: 'databridge',
  // the bulk violations fetch keyset-walks its ~18.5K citywide rows through the
  // table-style query - the sql row cap that kept this on carto only limits single
  // responses, not the walked set
  contractorViolations: 'databridge',
  // court_appeals and board_decisions are NOT in databridge (rechecked 2026-09-18) -
  // flip these when the tables land
  appealsCourtHistory: 'carto',
  zoningBoardHistory: 'carto',

  // appeals calendar: the date-window table query (the region-filter spatial query
  // stays on carto - no council_districts_2016 in databridge and its polygon exceeds a GET)
  appealsCalendar: 'databridge',
  // the calendar dots: SELECT DISTINCT is unsupported on PostgREST and its ~1,600
  // rows exceed the Carto V3 sql cap - flip when databridge can serve it
  appealsCalendarDots: 'carto',
  // the RCO name list, from the zoning_rco table
  rcos: 'databridge',
  // building footprints from building_footprints_3857 (the shifted table that aligns
  // with the Esri basemap); 'arcgis' selects the preserved AGO branch
  liBuildingFootprints: 'databridge',
};

export const API_SOURCES = USE_DATABRIDGE
  ? DATABRIDGE_SOURCES
  : Object.keys(DATABRIDGE_SOURCES).reduce((sources, key) => {
    const value = DATABRIDGE_SOURCES[key];
    sources[key] = value === 'databridge' ? 'carto' : value;
    return sources;
  }, {});
